<template>
  <custom-dialog
    width="1400px"
    class="select-part-dialog"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    :append-to-body="true"
  >
    <div
      class="dialog-body"
      ref="body"
    >
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item style="float: right; margin-right: 0;">
            <search-input
              :placeholder="i18n.placeholder_search"
              v-model="formSearch.search"
              @fetch="onPageChange({page: 1})"
            ></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          height="400px"
          :data="tableList"
          @filter="filterChange"
          @sort="sortChange"
          :tableCode="tableCode"
          v-model="selectData"
          type="checkbox"
        ></custom-table>
      </div>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialog">
        {{i18n.com_cancel}}
      </el-button>
      <el-button
        type="primary"
        @click="onSave"
      >
        {{i18n.com_confirm}}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  mixins: [dialogMixins, languageInjectMixins],
  props: {
    productCode: [String, Number],
    componentCode: [String, Number],
  },
  // computed: {
  //   title() {
  //     const titleAdd = this.i18n.dialog_title_add_topic;
  //     const titleEdit = this.i18n.dialog_title_edit_topic;
  //     return this.model.type === 'add' ? titleAdd : titleEdit;
  //   }
  // },
  data() {
    return {
      tableCode: 'parts_location_bind_part',
      formSearch: {
        search: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
      selectData: [],
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    getReqData() {
      return {
        ...this.formSearch,
        productCode: this.productCode,
        componentCode: this.componentCode
      };
    },
    getTableList() {
      this.$getJSON(apis.PartPreAssociatePage, this.getReqData()).then((res) => {
        const list = res.data.list;
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onSave() {
      this.closeDialog();
      this.$emit('confirm', this.selectData);
    },
    closeDialog() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
</style>
